/* eslint-disable max-lines, object-shorthand */

import API from "../modules/API";
import AddToCartButton from "../../bundles/NonMember/AddToCartButton.jsx";
import Button from "./Button";
import CheckoutModal from "../../bundles/Product/components/CheckoutModal";
import PropTypes from "prop-types";
import React from "react";
import SwapButton from "../../bundles/Swap/components/SwapButton";
import {connect} from "react-redux";
import {isMobile} from "../../lib/userAgent.js";

// {/* add logic here to display add to cart button instead of BIN button for clearance and retail store logged in */}
// {/* button should add item to cart and display any errors that come back */}
// {/* should post to api/v1/carts_controller */}

class ProductDetailButtons extends React.PureComponent {

  static propTypes = {
    "addToCartCallback": PropTypes.func.isRequired,
    "addWishListCallback": PropTypes.func.isRequired,
    "apiToken": PropTypes.string.isRequired,
    "buyItNowEligible": PropTypes.bool.isRequired,
    "customerId": PropTypes.string,
    "eligibleForFineJewelry": PropTypes.bool.isRequired,
    "inShipment": PropTypes.bool,
    "itemAvailability": PropTypes.number,
    "loadingAddToCart": PropTypes.bool,
    "nonMemberCartEnabled": PropTypes.bool.isRequired,
    "orderInfo": PropTypes.object.isRequired,
    "parentProps": PropTypes.object.isRequired,
    "previewSwapping": PropTypes.bool,
    "productDescriptors": PropTypes.array,
    "removeWishListCallback": PropTypes.func.isRequired,
    "showClearancePrice": PropTypes.bool.isRequired,
    "swapHandler": PropTypes.func,
    "warehouseClosed": PropTypes.bool,
    "warehouseClosedShopPageText": PropTypes.string,
    "wishlisted": PropTypes.bool
  };

  static defaultProps = {
    "customerId": "",
    "eligibleForFineJewelry": false,
    "inShipment": false,
    "itemAvailability": -1,
    "loadingAddToCart": false,
    "orderInfo": {},
    "previewSwapping": false,
    "productDescriptors": [],
    // eslint-disable-next-line no-empty-function
    "swapHandler": () => {},
    "warehouseClosed": false,
    "warehouseClosedShopPageText": "",
    "wishlisted": false
  };

  constructor (props) {
    super(props);
    this.state = {
      "modalOpen": false,
      "quantity": 1
    };
  }

  addWishListRequest = () => {
    const {
      addWishListCallback,
      "parentProps": {"productDescriptor": {id}}
    } = this.props;
    addWishListCallback(id, false);
  };

  addToCartRequest = () => {
    const {
      addToCartCallback,
      "parentProps": {"productDescriptor": {id}}
    } = this.props;

    const {quantity} = this.state;
    addToCartCallback(id, quantity);
  };

  removeWishListRequest = () => {
    const {"parentProps": {"productDescriptor": {id}}, removeWishListCallback} = this.props;
    removeWishListCallback(id, false);
  };

  handleOpenModal = () => {
    this.setState({"modalOpen": true});
  }

  renderNonMemberBINSection = () => {
    const {"parentProps": {productDescriptor}, itemAvailability, nonMemberCartEnabled, showClearancePrice} = this.props;
    const buttonText = {
      "-1": "Checking inventory...",
      "0": "Out of Stock",
      "default": "Add to Cart"
    };

    return (
      <div className="mb12">
        {
          !nonMemberCartEnabled &&
          <Button
            classes="btn-primary wide centered"
            disabled={itemAvailability < 1}
            onClick={this.handleBINRedirect}
            text={buttonText[itemAvailability] || buttonText.default}
          />
        }
        {
          nonMemberCartEnabled &&
          <AddToCartButton
            isItemAvailable={Boolean(itemAvailability)}
            productDescriptor={productDescriptor}
            showClearancePrice={showClearancePrice}
          />
        }
        <div className="center pt8 text-small">
          Free Shipping
          {" • "}
          Free Returns
        </div>
      </div>
    );
  }

  handleBINRedirect = () => {
    window.location = `${window.location.pathname}/checkout?${this.getUtmParameters()}`;
  }

  getUtmParameters = () => {
    const params = window.location.search.substring(1).split("&");
    const utmParams = params.filter(param => param.includes("utm")).join("&");
    return utmParams || "";
  }

  nonmemberShouldSeeBIN = () => {
    const {buyItNowEligible} = this.props;
    return buyItNowEligible;
  }

  isAvailableRetailStore = () => {
    const {orderInfo, "parentProps": {productDescriptor}} = this.props;
    let availableRetailStore = false;

    if (orderInfo[productDescriptor.id]) {
      availableRetailStore = orderInfo[productDescriptor.id]["retail?"];
    }

    return availableRetailStore;
  }

  loggedIn = () => API.CUSTOMER_ID

  handleCloseModal = () => this.setState({"modalOpen": false});

  renderAddToCart = () => {
    const {loadingAddToCart} = this.props;
    return (
      <div className="add-to-cart-section">
        <Button
          classes="btn-primary wide centered mb8"
          loading={loadingAddToCart}
          onClick={this.addToCartRequest}
          text={loadingAddToCart ? "" : "Add to Cart"}
        />
      </div>
    );
  }

  renderBuyOnClearanceButton = () => (
    <div>
      {this.renderAddToCart()}
      <Button
        classes="btn-secondary wide centered"
        onClick={this.handleOpenModal}
        text="Buy On Clearance"
      />
    </div>
  )

  renderBuyNowButton = () => {
    const {orderInfo, "parentProps": {"productDescriptor": {id}}} = this.props;
    const {"address_on_file": addressOnFile, "card_on_file": cardOnFile} = orderInfo[id];
    return (
      <div>
        { this.renderAddToCart()}
        {cardOnFile && addressOnFile &&
        <Button
          classes="btn-secondary wide centered"
          onClick={this.handleOpenModal}
          text="Buy Now"
        />
        }
      </div>
    );
  }

  renderAddToWishListButton = () => {
    const {wishlisted} = this.props;

    return (
      <Button
        classes="btn-primary wide centered mb8"
        onClick={wishlisted
          ? this.removeWishListRequest
          : this.addWishListRequest}
        text={`${wishlisted
          ? "Added"
          : "Add"} to Wish List`}
      />
    );
  }

  renderPreviewSwapButton = () => {
    const {"parentProps": {productDescriptor}, swapHandler, productDescriptors} = this.props;
    return (
      <SwapButton
        classes="btn-primary swap-button btn-small"
        onSwap={swapHandler}
        productDescriptor={productDescriptor}
        productDescriptors={productDescriptors}
        text="Swap"
      />
    );
  }

  renderCheckoutModal = () => {
    const {
      apiToken,
      customerId,
      parentProps,
      "parentProps": {"productDescriptor": {id}},
      orderInfo,
      warehouseClosed,
      warehouseClosedShopPageText
    } = this.props;
    const {modalOpen} = this.state;

    return (
      <CheckoutModal
        apiToken={apiToken}
        customerId={customerId}
        onCloseModal={this.handleCloseModal}
        open={modalOpen}
        parentProps={parentProps}
        pdOrderInfo={orderInfo[id]}
        warehouseClosed={warehouseClosed}
        warehouseClosedShopPageText={warehouseClosedShopPageText}
      />
    );
  }

  shouldRenderAddToWishlistButton = () => {
    const {
      "parentProps": {
        "productDescriptor": {
          "details": {
            "enough_to_wishlist": enoughToWishlist,
            "is_fine": isFine,
            wishlistable
          }
        }
      }, eligibleForFineJewelry, previewSwapping
    } = this.props;

    if (this.isAvailableClearanceStore() || this.isAvailableRetailStore()) {
      return false;
    }

    if (isFine && !eligibleForFineJewelry) {
      return false;
    }

    return this.loggedIn() && wishlistable && enoughToWishlist && !previewSwapping;
  }

  shouldRenderPreviewSwapButton = () => {
    const {previewSwapping, inShipment} = this.props;
    return this.loggedIn() && previewSwapping && !inShipment && !isMobile();
  }

  isAvailableClearanceStore = () => {
    const {orderInfo, "parentProps": {"productDescriptor": {id}}} = this.props;
    let availableClearanceStore = false;
    if (orderInfo[id]) {
      availableClearanceStore = orderInfo[id]["clearance?"];
    }
    return availableClearanceStore;
  }

  shouldRenderBuyClearanceButton = () => {
    const {showClearancePrice, previewSwapping} = this.props;
    return this.loggedIn() && showClearancePrice && !previewSwapping;
  }

  shouldRenderBuyNowButton = () => {
    const {previewSwapping} = this.props;
    return this.loggedIn() && !previewSwapping;
  }

  shouldRenderClearancePrice = () => {
    const {showClearancePrice} = this.props;
    return showClearancePrice && this.isAvailableClearanceStore();
  }

  render = () => (
    <div className="pd-detail-button-container">

      {this.shouldRenderAddToWishlistButton() && this.renderAddToWishListButton()}

      {this.shouldRenderPreviewSwapButton() && this.renderPreviewSwapButton()}

      {this.shouldRenderBuyClearanceButton() && this.isAvailableClearanceStore() && this.renderBuyOnClearanceButton()}

      {this.shouldRenderBuyNowButton() && this.isAvailableRetailStore() && this.renderBuyNowButton()}

      {!this.loggedIn() && this.renderNonMemberBINSection()}

      {this.loggedIn() && (this.shouldRenderClearancePrice() || this.isAvailableRetailStore()) &&
        this.renderCheckoutModal()
      }
    </div>
  )
}

const mapStateToProps = state => (
  {
    "apiToken": state.apiToken,
    "buyItNowEligible": state.buyItNowEligible,
    "customerId": state.customerId,
    "orderInfo": state.orderInfo,
    "pdPrices": state.pdPrices,
    "warehouseClosed": state.warehouseClosed,
    "warehouseClosedShopPageText": state.warehouseClosedShopPageText
  }
);

export default connect(mapStateToProps)(ProductDetailButtons);
